'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;

var _functional = require('../utils/functional');

var _listeners = require('../utils/listeners');

function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var key = el.dataset.modal;
  var els = {
    el: el,
    trigger: (0, _functional.getElement)('.' + context.className + '_Trigger[data-modal-trigger="' + key + '"]'),
    body: context.getElement('.' + context.className + '_Body'),
    close: context.getElement('.' + context.className + '_Close')
  };

  function handleTriggerClick() {
    els.el.classList.add('mod-Modal-active');
  }

  function closeModal() {
    els.el.classList.remove('mod-Modal-active');
  }

  var listeners = new _listeners.Listeners();
  listeners.add(els.trigger, 'click', handleTriggerClick);
  listeners.add(els.close, 'click', closeModal);
  listeners.add(els.el, 'click', closeModal);
  listeners.add(els.body, 'click', function (e) {
    return e.stopPropagation();
  });
}